<div *ngIf="data.order.client.oneTimeExtraInfo">
  <p class="title">Eenmalige extra info</p>
  <p class="extra-info-one-time">{{data.order.client.oneTimeExtraInfo}}</p>
</div>

<p class="title title2">Extra info aanpassen</p>
<ion-item>
  <ion-textarea (keyup.enter)="save()" placeholder="Vul hier extra info in" [(ngModel)]="text" class="input-text"
    value="{{data.order.client.extraInfo}}"></ion-textarea>
</ion-item>

<div class="action-buttons">
  <ion-button (click)="save()">
    Opslaan
  </ion-button>
</div>